import { useEffect } from 'react';
import { useTenantContext } from './useTenantContext';

/**
 * Hook to apply appropriate theme class based on role / impersonation.
 * - SuperAdmin (platform menu): Heglo brand colors (blue/green).
 * - TenantAdmin, or SuperAdmin impersonating a tenant: tenant mode, with the
 *   tenant's brand colors applied on top via useBrandingTheme.
 */
export function useDashboardTheme() {
  const { isSuperAdmin, isImpersonating } = useTenantContext();
  // Only the platform-menu SuperAdmin gets the Heglo skin; while impersonating
  // we drop to tenant mode so the tenant's branding governs the look.
  const useSuperAdminSkin = isSuperAdmin && !isImpersonating;

  useEffect(() => {
    const root = document.documentElement;

    if (useSuperAdminSkin) {
      root.classList.add('superadmin-mode');
      root.classList.remove('tenant-mode');
    } else {
      root.classList.remove('superadmin-mode');
      root.classList.add('tenant-mode');
    }

    // Cleanup on unmount
    return () => {
      root.classList.remove('superadmin-mode');
      root.classList.remove('tenant-mode');
    };
  }, [useSuperAdminSkin]);

  return { isSuperAdmin };
}
